import React from 'react';

export default function NotFound() {
    return (
      <div className="min-h-screen w-full bg-[#0f172a] flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white/5 border border-white/10 rounded-lg">
          <div className="p-6 flex flex-col items-center text-center space-y-8">
            {/* Error Icon */}
            <div className="rounded-full bg-red-500/10 p-3">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="w-8 h-8 text-red-500"
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            
            {/* Title and Description */}
            <div className="space-y-2">
              <h1 className="text-3xl font-bold tracking-tighter text-white">
                404 - Sayfa Bulunamadı
              </h1>
              <p className="text-zinc-400">
                Aradığınız sayfa mevcut değil veya taşınmış olabilir.
              </p>
            </div>
  
            {/* Divider and Button */}
            <div className="space-y-4 w-full">
              <div className="h-[1px] w-full bg-white/10" />
              
              <a 
                href="/" 
                className="inline-flex w-full items-center justify-center rounded-md border border-white/10 bg-white/10 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/20 focus:ring-offset-2 focus:ring-offset-[#0f172a]"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="mr-2 h-4 w-4" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="m12 19-7-7 7-7"/>
                  <path d="M19 12H5"/>
                </svg>
                Ana Sayfaya Dön
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
  
  